import api from './api'

export interface ReferralInfo {
  success: boolean
  code: string
  link: string
  referrer_reward: number
  referee_reward: number
  total_referrals: number
  total_earned: number
}

export interface ReferralStats {
  success: boolean
  total_referrals: number
  total_earned: number
  referrals: {
    username: string
    full_name?: string | null
    email?: string | null
    display_name?: string | null
    date: string
    reward: number
  }[]
}

export interface ReferralValidation {
  valid: boolean
  referrer_name?: string
  referee_reward?: number
}

export interface ReferralAvailability {
  available: boolean
  message?: string
}

export const referralService = {
  checkAvailability: async (code: string, excludeUserId?: string): Promise<ReferralAvailability> => {
    let url = `/api/referral/check-availability?code=${encodeURIComponent(code)}`
    if (excludeUserId) url += `&exclude_user_id=${encodeURIComponent(excludeUserId)}`
    const response = await api.get(url)
    return response.data
  },

  validateCode: async (code: string): Promise<ReferralValidation> => {
    const response = await api.get(`/api/referral/validate?code=${encodeURIComponent(code)}`)
    return response.data
  },

  getReferralInfo: async (): Promise<ReferralInfo> => {
    const response = await api.get('/api/referral/code')
    return response.data
  },

  getReferralStats: async (): Promise<ReferralStats> => {
    const response = await api.get('/api/referral/stats')
    return response.data
  },

  applyReferral: async (referral_code: string): Promise<{ success: boolean; message: string; wallet_balance?: number }> => {
    const response = await api.post('/api/referral/apply', { referral_code })
    return response.data
  },
}
